import { render, staticRenderFns } from "./Latest.vue?vue&type=template&id=df5c36f2"
import script from "./Latest.vue?vue&type=script&lang=ts"
export * from "./Latest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webp_aaeg4c7xsv2rwjah5qgerw23gy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsStory: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/news/Story.vue').default,UiCarousel: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/ui/Carousel.vue').default})
